

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import sidemenucss from "../../css/sidemenu.module.css";
import commoncss from "../../css/common.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { ReactComponent as BaseCorp } from "../../assets/icons/base-corp.svg";

import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusBlack.svg";

const FSSideMenu = ({
  menuItems,
  title,
  activeItem,
  activeItemSubMenu,
  notes,
  setActiveTab,

  handleTabs,
  handleTabsPNL,

  setActiveTabPNL,
  handleAddNotesClick,
  PnlSubMenus,
  disclosuresList,
  setDisclosuresTab,
  DisclosuresChecklistSubMenu,
  handleTabsDisclosureCheckList,
  setActiveTabDisclosureCheckList,
  bsNotes,
  setBSActiveTab,
  handleAddDiscNotesClick
}) => {
  const dispatch = useDispatch();

  const [openSubmenu, setOpenSubmenu] = useState(activeItem);

  const routerHistory = useHistory();
  console.log("PnlSubMenus", PnlSubMenus);
  const PnlSubMenusList = PnlSubMenus.map((item) => item.notes_grp);

  console.log("PnlSubMenusList", PnlSubMenusList);
  console.log("DisclosuresChecklistSubMenu", DisclosuresChecklistSubMenu);
  const [activeItemInPNLSubMenu, setactiveItemInPNLSubMenu] = useState(0);
  const [activeItemInGNSubMenu, setActiveItemInGNSubMenu] = useState(0);

  const [activeItemInBSSubMenu, setActiveItemInBSSubMenu] = useState(0);
  const [activeDiscSubMenu, setActiveDiscSubMenu] = useState(0);
  const [
    activeItemDisclosureCheckSubMenu,
    setactiveItemDisclosureCheckSubMenu,
  ] = useState(0);


 
  const handleClick = (Link) => {
    if (Link) {
      routerHistory.push(Link);
    }
  };
  
  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div
        className={sidemenucss.sidemenuHeader}
        style={{ "min-height": "15vh" }}
      >
        <span className={sidemenucss.sidemenuTitle}>{title}</span>
        {/* <span className={sidemenucss.sidemenuSubTitle}>workspace name</span> */}
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} ${commoncss.hideScroll} pt-0`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                // onClick={() => {
                //   // Toggle submenu visibility if the item has submenus
                //   if (item.subMenu) {
                //     setOpenSubmenu(openSubmenu === item.label ? null : item.label);
                //   } else {
                //     // Navigate if it's a top-level item without submenus
                //     handleClick(item.pagelink);
                //   }
                // }}
                onClick={() => {
                  dispatch({ type: "NOTE_KEY", payload: index });

                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === index ? sidemenucss.sidemenuItemActive : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                  </div>
                </span>
              </li>

              {/* {item.subMenu && openSubmenu === item.label && (
                <div className={sidemenucss.submenuContainer}>
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.pagelink)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              )} */}
              {activeItem === 4 && index === 4 && notes && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {notes.map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note.name
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}

                        className={`${sidemenucss.submenuItem} ${
                          activeItemInBSSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}

                        onClick={() => {
                          setBSActiveTab(index);
                          handleTabs(idx);
                          setActiveItemInBSSubMenu(idx);

                        }}
                      >
                        {note.name}
                      </div>
                    ))}
                    <div
                      className={` ${sidemenucss.activeSubMenu} ${commoncss.clickable}`}
                      onClick={() => {
                        handleAddNotesClick();
                      }}
                    >
                      <Plus /> Add note
                    </div>
                  </div>
                </>
              )}

              {activeItem === 5 && index === 5 && notes && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {bsNotes.map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note.name
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                        className={`${sidemenucss.submenuItem} ${
                          activeItemInGNSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}
                        onClick={() => {
                          setBSActiveTab(idx);
                          handleTabs(idx);
                          setActiveItemInBSSubMenu(idx);
                        }}
                      >
                        Note - {note.notes_grp}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {activeItem === 6 && index === 6 && notes && (
                <>
                  <div className={sidemenucss.submenuContainerPNL}>
                    {PnlSubMenusList.map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                        className={`${sidemenucss.submenuItem} ${
                          activeItemInPNLSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}
                        onClick={() => {
                          setActiveTabPNL(index);
                          console.log("clicked");
                          handleTabsPNL(idx);
                          setactiveItemInPNLSubMenu(idx);
                        }}
                      >
                        {note}
                      </div>
                    ))}
                    {/* <div
                    className={` ${sidemenucss.activeSubMenu}`}
                    onClick={() => {
                      handleAddNotesClick();
                    }}
                  >
                    <Plus/> Add note
                  </div> */}
                  </div>
                </>
              )}

              {activeItem === 7 && index === 7 && disclosuresList && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {disclosuresList.map((note, idx) => (
                      <div
                        key={idx}
                        className={`${sidemenucss.submenuItem} ${
                          activeDiscSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            :
                          null
                        }`}
                        onClick={() => {
                          setActiveTab(index);
                          setActiveDiscSubMenu(idx)
                          setDisclosuresTab(idx);
                        }}
                      >
                        {note.label}
                      </div>
                    ))}
                    <div
                      className={` ${sidemenucss.activeSubMenu}  ${commoncss.clickable}`}
                      onClick={() => {
                        handleAddDiscNotesClick();
                      }}
                    >
                      <Plus /> Add note
                    </div>
                  </div>
                </>
              )}
              {activeItem === 8 && index === 8 && notes && (
                <>
                  <div
                    className={sidemenucss.submenuContainerPNL}
                    style={{ maxHeight: "230px" }}
                  >
                    {DisclosuresChecklistSubMenu.map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                        className={`${sidemenucss.submenuItem} ${
                          activeItemDisclosureCheckSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}
                        onClick={() => {
                          setActiveTabDisclosureCheckList(index);
                          console.log("clicked");
                          handleTabsDisclosureCheckList(idx);
                          setactiveItemDisclosureCheckSubMenu(idx);
                        }}
                      >
                        {note.name}
                      </div>
                    ))}

                    {/* <div
                    className={` ${sidemenucss.activeSubMenu}`}
                    onClick={() => {
                      handleAddNotesClick();
                    }}
                  >
                    <Plus/> Add note
                  </div> */}
                  </div>
                </>
              )}
               {activeItem === 6 && index === 6 && notes && (
                <>
                  <div className={sidemenucss.submenuContainerPNL}>
                    {PnlSubMenusList.map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                         className={`${sidemenucss.submenuItem} ${
          activeItemInPNLSubMenu === idx ? sidemenucss.activeSubMenu : ""
        }`}
                        onClick={() => {
                          setActiveTabPNL(index);
                          console.log("clicked");
                          handleTabsPNL(idx);
                          setactiveItemInPNLSubMenu(idx);
                        }}
                      >
                        {note}
                      </div>
                    ))}
                  {/* <div
                    className={` ${sidemenucss.activeSubMenu}`}
                    onClick={() => {
                      handleAddNotesClick();
                    }}
                  >
                    <Plus/> Add note
                  </div> */}
                  </div>
                </>
              )}

              {activeItem === 7 && index === 7 && disclosuresList && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {disclosuresList.map((note, idx) => (
                      <div
                        key={idx}
                        className={`${sidemenucss.submenuItem} ${
                          // activeItemSubMenu === note.id
                          //   ? sidemenucss.activeSubMenu
                          //   : 
                            null
                        }`}
                        onClick={() => {
                          setActiveTab(index);
                          console.log("clicked");
                          setDisclosuresTab(idx);
                        }}
                      >
                        {note.label}
                      </div>
                    ))}
                    <div
                      className={` ${sidemenucss.activeSubMenu}`}
                      onClick={() => {
                        handleAddNotesClick();
                      }}
                    >
                      <Plus /> Add note
                    </div>
                  </div>
                </>
              )}
               {activeItem === 8 && index === 8 && notes && (
                <>
                  <div
                    className={sidemenucss.submenuContainerPNL}
                    style={{ maxHeight: "230px" }}
                  >
                    {DisclosuresChecklistSubMenu .map((note, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                         className={`${sidemenucss.submenuItem} ${
          activeItemDisclosureCheckSubMenu === idx ? sidemenucss.activeSubMenu : ""
        }`}
                        onClick={() => {
                          setActiveTabDisclosureCheckList(index);
                          console.log("clicked");
                          handleTabsDisclosureCheckList(idx);
                          setactiveItemDisclosureCheckSubMenu(idx);
                        }}
                      >
                        {note.name}
                      </div>
                    ))}

                    
                    
                  {/* <div
                    className={` ${sidemenucss.activeSubMenu}`}
                    onClick={() => {
                      handleAddNotesClick();
                    }}
                  >
                    <Plus/> Add note
                  </div> */}
                  </div>
                </>
              )}
              
              
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FSSideMenu;